import { Tag } from "primereact/tag";

type ContentTagProps = {
  value: string;
  severity?: null | "success" | "warning" | "secondary" | "info" | "danger" | "contrast";
  rounded?: boolean;
  className?: string;
  style?: React.CSSProperties;
};

export function ContentTag({
  value,
  severity = null,
  rounded = true,
  className = "bg-elevation-1",
  style,
}: ContentTagProps) {
  return (
    <Tag
      value={value}
      severity={severity}
      rounded={rounded}
      className={className}
      style={{ width: "fit-content", ...style }}
    />
  );
}
